module.exports = __webpack_public_path__ + "img/fun_radio.7090a8cc.jpg";